import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth.service';

/**
 * Guards the bare URL and unknown paths. A signed-in user goes to their landing page
 * ({@link AuthService.landingPage}) once staff access has loaded, as the splash page does after
 * sign-in: facility floor staff land on /floor, console staff on their first console page.
 * Signed-out users start sign-in, the same as PermissionGuard.
 */
export const defaultRouteGuard: CanActivateFn = async () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  try {
    await auth.tryLoginIfNeeded();
  } catch {
    return router.parseUrl('/unauthorized');
  }
  if (!auth.isLoggedIn()) {
    auth.login();
    return false;
  }
  if (!await auth.loadStaffAccess()) return router.parseUrl('/unauthorized');
  return router.parseUrl(auth.landingPage());
};
